<script>
  import { goto } from '$app/navigation';
  import Button from '$lib/components/common/buttons/Button.svelte';
  import GardenLogoAltIcon from '$lib/icons/GardenLogoAltIcon.svelte';
  import KeyboardHintIcon from '$lib/icons/KeyboardHintIcon.svelte';

</script>

<div
  class="flex flex-col items-center justify-center min-h-screen py-12 bg-gray-100 md:py-24 lg:py-32"
>
  <div class="container flex flex-col items-center gap-3 px-4 text-center md:gap-6">
    <div class="flex items-center flex-col space-y-2">
      <GardenLogoAltIcon width={120} />
      <h1 class="text-3xl font-bold tracking-tighter sm:text-5xl md:text-6xl">
        Oops! Page not found
      </h1>
      <p
        class="max-w-[600px] text-gray-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-400"
      >
        Sorry, we couldn't find the page you're looking for.
      </p>
    </div>
    <div class="flex w-full items-center justify-center gap-4 min-[400px]:gap-8">
      <Button on:click={() => goto('/explore')}>Go to explore <KeyboardHintIcon /></Button>
    </div>
  </div>
</div>
